import React, { useState } from 'react'
import CustomTable from '../../../../customComponents/CustomTable'
import { TABLE_DATA,TABLE_HEADERS,keyMapping } from '../../../../../constants/LeadSourceList'
import downloadIcon from './../../../../../Assets/icons/download.svg'
import './index.scss'
import ListFilters from '../../OnBoardManagement/ListFilters'
import { useNavigate } from 'react-router-dom';
const LeadSourceList = () => {
 console.log("data>>>",TABLE_DATA);
 const navigate=useNavigate()
 // const columns = ['id', 'name', 'age', 'email'];
  return (
    <div>
      <div className='OnboardManagamentContainer'>
      <div className='OnboardManagamentbuttonContainer'>
        <h5>Lead Management</h5>
       
        </div>
        
        <div>
        <button className='addcustomerbutton' onClick={()=>navigate('/admin/manage-lead/lead-source/add-lead-source')}>Add Lead Priority</button>
      </div>
    
      </div>
     
    
      <div className='tableWrapper'>
      <div className='admin-list-container'>
      <div className='listsearchContainer'>
        <h5>Lead Source List</h5>
        
        <input type='text' className='searchinput' placeholder='Search Source' />
      </div>
      <div className='downloadiconwrapper'>
        <h6 className='downloadTitle'>Download</h6><img src={downloadIcon} alt='download'/>
      </div>
      </div>
     
      <CustomTable data={TABLE_DATA} headers={TABLE_HEADERS} keyMapping={keyMapping} itemsPerPage={5}/>
      </div>
      
      </div>
  )
}

export default LeadSourceList